import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { ASSESSMENT_FORMATIVE_CREATE, ASSESSMENT_FORMATIVE_LIST, GLOBAL_STATE } from '../constants/actionTypes'

const assessmentFormativeSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const assessmentFormativeCreateSelector = createSelector(
  assessmentFormativeSelector,
  data => data[ASSESSMENT_FORMATIVE_CREATE]
)

export const assessmentFormativeListSelector = createSelector(
  assessmentFormativeSelector,
  data => data[ASSESSMENT_FORMATIVE_LIST]
)
